import AffiliatesList from './components/AffiliatesList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import get from 'lodash/get';
import { connect } from 'react-redux';
import './AffiliateList.css'

import {
    loadAffiliates,
  loadBrands
} from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
    const brandId = props.brandId;
  const brands = values(state.entities.companies)
    .filter((b) => b.name && b.name.length > 0 && b.isBrand)
    .sort((a,b) => (a.name || '').localeCompare((b.name || '')))
    const affiliates = values(get(state,['entities','affiliates'],{}))
        .map((r) => {
            r.brand = brands.filter((b) => b.id === r.brandId).shift() || {};
            r.agency = get(state,['entities','agencies', r.agencyId], {});
            return r;
        })

  return {
    affiliates: brandId ? affiliates.filter((r) => r.brandId === brandId) : affiliates,
      shouldLoad:values(get(state,['entities','affiliates'],{})).length === 0,
    brands:brands,
      brandId: brandId
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
      loadAffiliates,
    loadBrands
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(AffiliatesList));



// WEBPACK FOOTER //
// ./src/routes/AffiliatesList/index.js